import React from "react";

import './Choose.scss';

const CaseComponent = ({ data }) => {
  const { title, description, number } = data;
  return (
    <div className="dc-case">
      <div className="title-container">
        <div className="number-container">
          <div className="number">{number}</div>
        </div>
        <h3 className="title">{title}</h3>
      </div>
      <div className="description">{description}</div>
    </div>
  );
}

export default function dc({ data }) {
  const { title, description, cases } = data;
  return (
    <div className="dc-wrapper">
      <div className="dc-content">
        <div className="dc-text">
          <h2 className="dc-title">{title}</h2>
          <div className="dc-description">{description}</div>
        </div>
        <div className="dc-cases">
          {cases.map((caseData) => <CaseComponent data={caseData} />)}
        </div>
      </div>
    </div>
  )
}